// extracted by mini-css-extract-plugin
export var attribution = "_a3-4";
export var authorName = "_a3-5";
export var quote = "_a3-3";
export var testimonial = "_a3-2";
export var trustedBy = "_a3-0";
export var trustedByLabel = "_a3-1";